import { Box, Typography, styled } from "@mui/material"
import { colors } from "../../../../styles/commonStyles"
import { convertToInternationalNumberSystem } from "../../../../helper/utils/formatting"

export const DrawerContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: 860,
  // padding: "18px 21px",
  paddingTop: "10vh",
  //   zIndex: 10000000,
}))

const headersToCapsLock = ["Cytd", "Py", "pytd", "ttm"]

const capitalizeMatchingWord = (sentence: string) => {
  // Split the sentence into words
  const words = sentence.split(/\s+/)
  // Iterate over each word in the sentence
  const capitalizedWords = words.map((word) => {
    // Check if the word exists in the headersToCapsLock array
    const matchIndex = headersToCapsLock.findIndex(
      (header: any) => header.toLowerCase() === word.toLowerCase(),
    )

    // If the word exists in headersToCapsLock, capitalize it
    if (matchIndex !== -1) {
      return word.toUpperCase()
    }

    // Otherwise, return the word as is
    return word
  })
  // Join the words back into a sentence
  return capitalizedWords.join(" ")
}

export const DrawerHeader = styled(Box)(() => ({
  display: "flex",
  height: "70px",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: "1px soild #000000",
  padding: "20px",
}))

export const DrawerMainContainer = styled(Box)(() => ({
  // border: "1px solid red",
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  height: "100%",
  padding: "0px",
  overflowY: "scroll",
}))

export const DrawerSearchContainer = styled(Box)(() => ({}))

export const DrawerMiddle = styled(Box)(() => ({
  flex: 1,
  width: "100%",
  margin: "10px 0",
  padding: "10px",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  flexDirection: "column",
}))

export const DrawerCell = (props: any) => {
  const { type } = props
  const { column_name, column_color, column_data_type, column_value } =
    props?.cell

  return (
    <Box
      sx={{
        borderRight: "1px solid #E4E4E4",
        borderBottom: "1px solid #E4E4E4",
        height: "70px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 20px",
        flex: type == "1" ? "0 0 50%" : "0 0 33.3333%",
      }}
    >
      <Typography textTransform={"capitalize"} fontSize={14}>
        {capitalizeMatchingWord(column_name)}
      </Typography>
      <Box
        sx={{
          padding: "10px",
          backgroundColor:
            column_color == "red"
              ? colors.primaryRed
              : column_color == "green"
              ? colors.primaryGreen
              : column_color == "yellow"
              ? colors.primaryYellow
              : colors.primaryWhite,
          color:
            column_color == "red"
              ? colors.primaryWhite
              : column_color == "green"
              ? colors.primaryWhite
              : colors.primaryBlack,
        }}
      >
        {column_value ? (
          <Typography fontSize={14} fontWeight={600}>
            {convertToInternationalNumberSystem(column_value, column_data_type)}
          </Typography>
        ) : (
          <Typography fontSize={14} fontWeight={600}>
            -
          </Typography>
        )}
      </Box>
    </Box>
  )
}
export const DrawerOpportunityCard = (props: any) => {
  const { opportunity_name, opportunity_value } = props?.op

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        border: "1px solid #E4E4E4",
        height: "70px",
        flex: "1",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "20px",
        margin: "0 5px",
        borderRadius: "4px",
      }}
    >
      <Typography fontSize={12}>{opportunity_name}</Typography>
      {opportunity_value ? (
        <Typography fontSize={18} fontWeight={600}>
          {opportunity_value}
        </Typography>
      ) : (
        <Typography fontSize={18} fontWeight={600}>
          -
        </Typography>
      )}
    </Box>
  )
}
export const DrawerGoalCard = (props: any) => {
  const { column_name, column_color, column_datatype, column_value } =
    props?.goal

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        border: "1px solid #E4E4E4",
        height: "70px",
        flex: "1",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "10px",
        margin: " 0 5px",
        borderRadius: "4px",
      }}
    >
      <Typography textTransform={"capitalize"} fontSize={12}>
        {column_name}
      </Typography>
      {column_value ? (
        <Typography fontSize={18} fontWeight={600}>
          {column_value == "NA"
            ? "NA"
            : convertToInternationalNumberSystem(column_value, column_datatype)}
        </Typography>
      ) : (
        <Typography fontSize={18} fontWeight={600}>
          -
        </Typography>
      )}
    </Box>
  )
}
export const DrawerStatementCard = (props: any) => {
  const { statement } = props

  return (
    <>
      {statement ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            border: "1px solid #E4E4E4",
            // height: "70px",
            backgroundColor: "#F7F7F8",
            flex: "1",
            alignItems: "flex-start",
            justifyContent: "center",
            padding: "20px",
            margin: " 0 5px",
            borderRadius: "4px",
          }}
        >
          <Typography fontSize={16}>Impact Statement</Typography>
          <Typography
            fontSize={13}
            sx={{ color: colors.primaryGrey, marginTop: "10px" }}
            fontWeight={400}
          >
            {statement}
          </Typography>
        </Box>
      ) : null}
    </>
  )
}

export const DrawerSection = styled(Box)(() => ({
  // border: "1px solid red",
  borderLeft: "1px solid #E4E4E4",
  borderTop: "1px solid #E4E4E4",
  flexWrap: "wrap",
  width: "100%",
  // margin: "10px 0",
  // padding: "10px",
  display: "flex",
  // alignItems: "flex-start",
  // justifyContent: "flex-start",
  // flexDirection: "column",
}))

export const ChartWrapper = styled(Box)({
  padding: "15px",
  backgroundColor: "#fff",
  borderRadius: "4px",
  boxShadow: "0px 2px 8px #00000022",
  width: "100%",
})

export const ButtonContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  marginTop: "auto",
}))

export const DrawerCancelButton = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "138px",
  height: "40px",
  borderRadius: "4px",
  outline: "1px solid #4A79E7",
  cursor: "pointer",
}))

export const DrawerAssignButton = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "138px",
  height: "40px",
  borderRadius: "4px",
  marginLeft: "38px",
  backgroundColor: "#4A79E7",
  cursor: "pointer",
}))
